<template>
  <span class="avatar-container" :data-toggle="editable ? 'dropdown' : ''" ref="avatar">
    <!-- <VueAvatar v-if="(name || image) && (circleMode || !image)" :username="name" :size="size" :class="[editable ? 'avatar-editable' : '']" :backgroundColor="backgroundColor" :src="image" /> -->
    <img v-if="image" :src="image" :class="['avatar-non-circle', editable ? 'avatar-editable' : '', circleMode ? 'avatar-circle' : '']" :style="{'width': size + 'px', 'height': size + 'px'}" />
    <div v-if="!image && name" :class="['avatar-non-circle', editable ? 'avatar-editable' : '', circleMode ? 'avatar-circle' : '']" :style="{'background-color': backgroundColor, 'width': size + 'px', 'height': size + 'px'}" />
    <slot />
    <div v-if="editable" class="avatar-editable-hover avatar-circle-border" :style="{'width': size + 'px', 'height': size + 'px', 'line-height': size + 'px'}">
      Edit Image
    </div>
    <ul class="dropdown-menu" v-if="editable">
      <DropdownMenuItem icon="fa-pencil" @click="$emit('editImage')">Update image</DropdownMenuItem>
      <DropdownMenuItem icon="fa-trash-alt" @click="$emit('removeImage')" v-if="image">Remove image</DropdownMenuItem>
    </ul>
  </span>
</template>

<style>
.avatar-container {
  position: relative;
  display: inline-block;
}
.avatar-circle-border {
  border-radius: 50%;
}
.avatar-circle {
  border-radius: 50%;
  vertical-align: middle;
  color: #ffffff;
  font-weight: bold;
  position: relative;
}
.avatar-circle-lg {
  width: 128px;
  height: 128px;
  font-size: 36px;
  line-height: 96px;
}
.avatar-editable:hover, .avatar-editable:active {
  cursor: pointer;
}
.avatar-editable-hover {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  opacity: 0;
  background-color:rgba(0, 0, 0, 0.45);
  z-index:9999;
  color:white;
  border: 2px solid #606060;
  font-size: 15px;
  font-weight: normal;
  cursor: pointer;
  transition: opacity 0.15s;
}
.avatar-editable-hover:hover {
  opacity: 1;
}
</style>

<script>
// TODO: Remove vue-avatar if we don't eventually use it
// TODO: Probably will generate avatars from initials on server as images in future (other platforms seem to do that)
//import VueAvatar from 'vue-avatar'

export default {
  name: "Avatar",
  props: {
    image: String,
    name: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 128
    },
    editable: {
      type: Boolean,
      default: false
    },
    circleMode: {
      type: Boolean,
      default: true
    }
  },
  components: {
    //VueAvatar
  },
  methods: {
  },
  computed: {
    backgroundColor() {
      if(this.name == null || this.name == '')
        return null

      // Overwrite the background colour selection provided by vue-avatar as it isn't great looking
      let bgColours = [
        '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e',
        '#16a085', '#27ae60', '#2980b9', '#8e44ad', '#2c3e50',
        '#f1c40f', '#e67e22', '#e74c3c', '#c7ecee', '#95a5a6',
        '#f39c12', '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d'
      ]

      return bgColours[this.name.length % (bgColours.length)]
    }
  }
};
</script>